import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock';
import {View, Utils } from '../vendor/kerneljs';


let ariaSelect = require('aria-listbox');


const CustomSelect = View.extend({

	events: {
		'click .js--custom-select-trigger': 'triggerClickHandler',
		'selection-changed .js--custom-select-list': 'selectionChange',
		'keydown': 'keyHandler'
	},

	initialize: function(settings){

		this.trigger = this.find('.js--custom-select-trigger');

		this.list = this.find('.js--custom-select-list');
		this.listOptions = this.find('.custom-select__list__item');

		this.label = this.find('.js--custom-select-label');
		this.hiddenInput = this.find('.js--custom-select-input');


		this.selectedLabel = this.label.dataset.selected;
		this.valueChosen = false;
		this.multiple = this.label.dataset.multiple;
		this.autoSize = this.label.dataset.autosize;

		ariaSelect( this.list );

		this.disabled = this.hasClass('is-disabled');

		Utils.on(window, 'keydown', this.keyHandler.bind(this) );

		this.eventEmitter.on('customselect:open', this.openHandler.bind(this) );

		this.el.addEventListener('customselect:focus', this.forceOpen.bind(this));

		this.active = false;


		this.bodyRef = Utils.find('body')[0];
		this.pageWrapperRef = Utils.find('.page-wrapper')[0];
		Utils.on(this.pageWrapperRef, 'touchstart', this.bodyClickHandler.bind(this) );
		Utils.on(this.bodyRef, 'click',  this.bodyClickHandler.bind(this) );

		this.setSelectedValue();
	},

	triggerClickHandler: function(event) {

		event.stopPropagation();

		if ( !this.disabled ) {
			this.active = !this.active;

			if (this.active) {
				this.show();
			}
			else {
				this.hide();
			}
		}
	},

	show: function() {
		this.adjustPosition();

		setTimeout(function(){
			this.addClass('is-active');
			this.addClass('is-filled');
			this.addClass('has-focus');

			this.eventEmitter.emit('customselect:open', this.instanceId);
			disableBodyScroll(this.find('.js--iosscrollfix'));

		}.bind(this), 50);
	},

	hide: function(refocusTrigger) {
		this.removeClass('is-active');
		this.removeClass('has-focus');

		if ( !this.valueChosen ) {
			this.removeClass('is-filled');
		}
		setTimeout(function(){
			this.list.setAttribute('style','');
			if ( refocusTrigger ) this.trigger.focus();

			enableBodyScroll(this.find('.js--iosscrollfix'));
		}.bind(this), 200);
	},

	openHandler: function(instanceId) {
		if ( typeof instanceId === "undefined") {
			//EVENT FAIL
		}
		else if ( instanceId === this.instanceId ) {
			//CLICKED SELF
		}
		else {
			this.forceClose();
		}
	},

	forceClose: function(refocusTrigger) {
		this.active = false;
		this.hide(refocusTrigger);
	},

	forceOpen: function(event) {
		this.active = true;
		this.trigger.focus();
		this.show();
	},

	keyHandler: function(event) {
		if (this.disabled) return;
	
		let key = event.which || event.keyCode || 0;
	
		if (this.active) {
			this.handleActiveKey(event, key);
		} else if (document.activeElement === this.trigger) {
			this.handleInactiveKey(event, key);
		}
	},
	
	handleActiveKey: function(event, key) {
		if (this.isUpKeyOnFirstElement(key)) {
			this.forceClose(true);
		} else if (this.isEscapeKey(key)) {
			this.forceClose(true);
		} else if (this.isDownKeyOnTrigger(event, key)) {
			this.list.firstElementChild.focus();
			event.preventDefault();
		} else if (this.isEnterKeyOnList(key)) {
			event.preventDefault();
		} else if (this.isSpaceOrUpOrDownKey(key)) {
			event.preventDefault();
		} else if (this.isTabKey(key)) {
			this.forceClose();
		}
	},
	
	handleInactiveKey: function(event, key) {
		if (this.isDownKey(key)) {
			this.forceOpen();
			this.list.firstElementChild.focus();
			event.preventDefault();
		} else if (this.isSpaceKey(key)) {
			this.forceOpen();
			event.preventDefault();
		}
	},
	
	isUpKeyOnFirstElement: function(key) {
		return document.activeElement === this.list.firstElementChild && key === 38;
	},
	
	isEscapeKey: function(key) {
		return key === 27;
	},
	
	isDownKeyOnTrigger: function(event, key) {
		return key === 40 && document.activeElement === this.trigger;
	},
	
	isEnterKeyOnList: function(key) {
		return key === 13 && document.activeElement !== this.trigger;
	},
	
	isSpaceOrUpOrDownKey: function(key) {
		return key === 32 || key === 38 || key === 40;
	},
	
	isTabKey: function(key) {
		return key === 9;
	},
	
	isDownKey: function(key) {
		return key === 40;
	},
	
	isSpaceKey: function(key) {
		return key === 32;
	},

	bodyClickHandler: function(event) {
		if ( !this.disabled ) {
			if ( this.active ) {
				let foundEl = Utils.closestByClass(event.target,'js--custom-select');

				if ( !foundEl ) {
					this.forceClose();
				}
			}
		}
	},

	setSelectedValue() {
		let selected = [],
			labelString = '';


		[...this.listOptions].map((el) => {
			if ( el.getAttribute('aria-selected') === 'true' ) {
				selected.push(el);
			}
			return null
		});

		let selectedCount = selected.length;

		if ( selectedCount > 0 ) {

			if ( this.multiple ) {
				labelString = selected.length + ' ' + this.selectedLabel;
			}
			else {
				labelString = selected[0].dataset.value;
			}
			this.label.innerHTML = labelString;
			this.valueChosen = true;
			this.addClass('is-filled');
		}
	},

	selectionChange: function(event) {

		let selectedCount = event.selection.length,
			labelString = '',
			valueString = '';

		if ( selectedCount > 0 ) {

			[...event.selection].map((el) => {
				valueString += el.dataset.value + ',';
				return null
			});

			valueString = valueString.slice(0, -1);

			labelString = selectedCount + ' ' + this.selectedLabel;
			this.valueChosen = true;
		}
		else if ( !this.multiple ) {
			labelString = event.selection.dataset.value;
			this.valueChosen = true;
		}
		else {
			this.valueChosen = false;
		}


		this.label.innerText = labelString;

		this.hiddenInput.setAttribute('value', valueString);


		this.eventEmitter.emit('customselect:change', this.settings.index); //Focus next custom-select

		if ( !this.multiple ) this.forceClose();
	},


	adjustPosition() {
		let vW = document.body.clientWidth,
			style = 'display:block;';

		this.list.setAttribute('style',style);

		let triggerBCR = this.trigger.getBoundingClientRect(),
			triggerBCRW = triggerBCR.width,

			listBCR = this.list.getBoundingClientRect(),
			listBCRL = listBCR.left

		if ( triggerBCRW > 250 || !this.autoSize ) {
			// Log.db("The select is wide enough to house full width list")
			//The select is wide enough to house full width list
			style += 'right:0;left:0;';
		}
		else if (listBCRL > vW/2 ) {
			// Log.db("All of the select is in the right viewport portion")
			//All of the select is in the right viewport portion
			style += 'right:0;left:auto;';
		}
		else {
			// Log.db("Some of the select is in the left viewport portion")
			//Some of the select is in the left viewport portion
			style += 'right:auto;left:0;';
		}

		this.list.setAttribute('style',style);
	}

});

(function(){
	Utils.each(Utils.find('.js--custom-select'), function(elem) {
		if ( !Utils.hasClass(elem, 'is-custom') ) new CustomSelect( {el: elem} );
	});
})();

export default CustomSelect
